// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"a6b5f3b7","36":"91ada27e","230":"a7ef01ac","341":"3842c3dc","791":"991695a3","840":"9e9d5f2a"}[chunkId] + ".chunk.css";
};